import { actionTypes } from "../actions/companies";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANIES:
      return action.payload;
    default:
      return state;
  }
};

export default variable;